import { Link, LinkProps } from '@ampcore/adel-react'
import React from 'react'

import { useAmpUserStatus } from '../../hooks/useAmpUserStatus'
import { DisplayForValues } from '../../types/DisplayForRule.type'
import { UserStatus } from '../../types/UserStatus.enum'

export type LinkCompoundProps = LinkProps & {
  displayFor?: DisplayForValues
}

const displayForMap: Record<UserStatus, DisplayForValues[]> = {
  [UserStatus.CLIENT_ACTIVE]: [
    DisplayForValues.CLIENT_ACTIVE,
    DisplayForValues.CLIENT_ACTIVE_OR_CLIENT_EXPIRED,
    DisplayForValues.ALL
  ],
  [UserStatus.CLIENT_EXPIRED]: [
    DisplayForValues.CLIENT_EXPIRED,
    DisplayForValues.CLIENT_ACTIVE_OR_CLIENT_EXPIRED,
    DisplayForValues.ALL
  ],
  [UserStatus.PROSPECT]: [DisplayForValues.PROSPECT, DisplayForValues.ALL]
}

export const LinkCompound = (props: LinkCompoundProps) => {
  const { displayFor, ...linkProps } = props

  const userStatus = useAmpUserStatus()

  if (displayFor) {
    const allowedValues = displayForMap[userStatus] ?? [DisplayForValues.ALL]

    return allowedValues.some(value => displayFor === value) ? (
      <Link {...linkProps} />
    ) : null
  }

  return <Link {...linkProps} />
}
